import type { Tab, TabToolbarState } from '@/types/tabTypes';

// AppMenuBar = 2.5rem (h-10), TopToolbar = 7rem (h-28)
export const TOOLBAR_TOP = '9.5rem';

export const DEFAULT_TOOLBAR_STATE: TabToolbarState = {
  vehicleEnabled: false,
  textToCadSelected: false,
  vehicleTab: 'space',
  vehicleSubTab: 'rocket-nozzle',
};

export interface FullTab extends Tab {
  type: 'home' | 'editor' | 'files' | 'marketplace';
  conversationId?: string;
  toolbarState: TabToolbarState;
}

export function createHomeTab(): FullTab {
  return {
    id: crypto.randomUUID(),
    type: 'home',
    title: 'New Tab',
    toolbarState: { ...DEFAULT_TOOLBAR_STATE },
  };
}

export function getInitialTabsState(): {
  tabs: FullTab[];
  activeTabId: string;
} {
  try {
    const raw = localStorage.getItem('tk-tabs');
    const activeRaw = localStorage.getItem('tk-active-tab');
    if (raw) {
      // Filter out legacy 'files' and 'marketplace' tabs — both are fixed-position.
      const parsed = (JSON.parse(raw) as FullTab[]).filter(
        (t) => t.type !== 'files' && t.type !== 'marketplace',
      );
      if (Array.isArray(parsed) && parsed.length > 0) {
        const activeId =
          activeRaw && parsed.some((t) => t.id === activeRaw)
            ? activeRaw
            : parsed[0].id;
        return { tabs: parsed, activeTabId: activeId };
      }
    }
  } catch (_) {
    // ignore malformed localStorage data
  }
  const fresh = createHomeTab();
  return { tabs: [fresh], activeTabId: fresh.id };
}
